export const FLAG_BASE_URL =
  'https://purecatamphetamine.github.io/country-flag-icons/3x2/{COUNTRY_SHORT}.svg'
